<template>
  <b-modal
    id="releaseNotes"
    size="lg"
    content-class="rn-mmp-modal menu-bg-blue-transparent-modal"
    header-class="rn-modal-header"
    footer-class="rn-modal-footer"
    body-class="rn-modal-body"
    no-close-on-backdrop
    scrollable
  >
    <template #modal-header>
      <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
        <h5 class="mb-0" style="font-weight: 600; color: white; font-size: 0.95rem; letter-spacing: 0.02em;">Release Notes</h5>
        <!-- <fa size="lg" style="color: rgba(255,255,255,0.85); cursor: pointer;" :icon="['fas', 'window-close']" @click="$bvModal.hide('releaseNotes')" /> -->
      </div>
    </template>
    <b-container fluid>
      <b-row class="py-1 my-1">
        <label class="rn-version-label px-3 mx-3 text-center">
          Version {{ this.versionReleaseInfo.version }} &nbsp;|&nbsp;
          {{ this.versionReleaseInfo.release_date }}
        </label>
      </b-row>
      <b-row class="px-1 m-1">
        <p class="rn-notes-text" style="white-space: pre-line">
          {{ this.versionReleaseNotes.toString() }}
        </p>
      </b-row>
    </b-container>
    <template #modal-footer>
      <b-row class="w-100 justify-content-end m-0">
        <b-button class="rn-got-it-btn px-4" @click="UpdateUserAcknw">Got it!</b-button>
      </b-row>
    </template>
  </b-modal>
</template>

<style>
.rn-modal-header {
  background: #063c6d !important;
  border-bottom: none !important;
  padding: 12px 16px !important;
  border-radius: 7px 7px 0 0 !important;
}

.rn-modal-body {
  background: #ffffff !important;
  color: #063c6d !important;
}

.rn-modal-footer {
  background: #ffffff !important;
  border-top: 1px solid rgba(6, 60, 109, 0.1) !important;
  padding: 10px 16px !important;
}

.rn-version-label {
  color: rgba(6, 60, 109, 0.6);
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.rn-notes-text {
  color: #063c6d;
  font-size: 0.9rem;
  line-height: 1.7;
}

.rn-got-it-btn {
  background: #063c6d !important;
  border-color: #063c6d !important;
  color: white !important;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.85rem;
}

.rn-got-it-btn:hover {
  background: #0a5499 !important;
  border-color: #0a5499 !important;
}
</style>

<script>
import axios from 'axios'
export default {
  name: 'MMP_ReleaseNotes',
  data() {
    return {
      userId: null,
      versionReleaseInfo: [],
      versionReleaseNotes: []
    }
  },
  methods: {
    getVersionRelease(user) {
      if (user == null || user == undefined || user.org == null || user.id == null) {
        console.log('User Undefined')
        return
      }
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION + '/api/release_notes/checkReleaseVersion',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {id: user.org}
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log(content.errors)
            } else {
              this.versionReleaseInfo = content
              this.versionReleaseNotes = []
              content.forEach(element => {
                this.versionReleaseNotes.push(element.notes)
              })
              this.versionReleaseNotes = this.versionReleaseNotes
                .join('|')
                .replaceAll('|', '\n\n')
              if (this.versionReleaseInfo.length > 0) {
                if (
                  this.versionReleaseInfo[0].organization_id == user.org ||
                  this.versionReleaseInfo[0].organization_id == 0
                ) {
                  this.userId = user.id
                  axios
                    .get(
                      process.env.API_LOCATION +
                        '/api/release_notes/userVersionAcknowledgement',
                      {
                        headers: {
                          'x-auth-token': sessionStorage.token
                        },
                        params: {
                          id: user.id
                        }
                      }
                    )
                    .then(response => {
                      const content = response.data
                      if (content.errors) {
                        console.log(content.errors)
                      } else {
                        if (content[0].version_acknw == null) {
                          this.$bvModal.show('releaseNotes')
                        }
                      }
                    })
                    .catch(function (error) {
                      console.log(error)
                    })
                }

                this.versionReleaseInfo = this.versionReleaseInfo[0]
              }
              
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    UpdateUserAcknw() {
      // REFACTOR: add check for userId = null
      axios
        .get(
          process.env.API_LOCATION + '/api/release_notes/updateAcknowledgement',
          {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              id: this.userId
            }
          }
        )
        .then(response => {
          const content = response.data
          if (!content.errors) {
            this.$bvModal.hide('releaseNotes')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>
